mutation revokeCancellation($companyId: ID!) {
  revokeCancellation(companyId: $companyId)
}
